import type { FC } from "react";
import { Checkbox, InformationIcon, Row, Tooltip } from "@hightouch/htui";

export type ParameterizeCheckboxProps = {
  isDisabled?: boolean;
  isChecked: boolean;
  onToggle: (isChecked: boolean) => void;
  tooltipMessage?: string;
};

const DEFAULT_TOOLTIP_MESSAGE =
  "Parameterizing a filter allows users to select a value at the audience level. For example: set a “Revenue” metric with “Brand” as a parametrized filter, and users can select the relevant brand for each audience.";

export const ParameterizeCheckbox: FC<Readonly<ParameterizeCheckboxProps>> = ({
  isDisabled = false,
  isChecked,
  onToggle,
  tooltipMessage = DEFAULT_TOOLTIP_MESSAGE,
}) => {
  return (
    <Row alignSelf="flex-start" gap={1} alignItems="center">
      <Checkbox
        label="Parameterize"
        isDisabled={isDisabled}
        isChecked={isChecked}
        onChange={(event) => {
          onToggle(event.target.checked);
        }}
      />
      <Tooltip message={tooltipMessage}>
        <InformationIcon />
      </Tooltip>
    </Row>
  );
};
